import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {ConstantsService} from '../../../services/constants.service';
import {SettingsAmenitiesService} from '../../../services/settings-amenities.service';
import {UrlService} from '../../../services/url.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'payment-modal',
    templateUrl: './payment-modal.component.html',
    styleUrls: ['./payment-modal.component.scss']
})
export class PaymentModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    fees: Array<any> = [];
    disabledSubmit = false;

    constructor(
        public api: ApiClientService,
        public urlService: UrlService,
        public settingsAmenitiesService: SettingsAmenitiesService
    ) {}

    ngOnInit() {
        this.initData();
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initData() {
        this.fees = this.settingsAmenitiesService.selectedItemData.fees.map(
            (fee) => Object.assign({}, {
                active: fee.active,
                required: fee.required,
                name: fee.name,
                amount: fee.amount,
                refundable: fee.refundable,
                pmtAtTime: fee.pmtAtTime,
                pmtHourly: fee.pmtHourly,
                availableWaive: fee.availableWaive
            })
        );
        if(this.fees.length < 1)
            this.fees = [{active: false, required: false, name: '', amount: '0', refundable: false, pmtAtTime: false, pmtHourly: false, availableWaive: false}];
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.settingsAmenitiesService.isPaymentModalShow = false;
                    this.settingsAmenitiesService.serviceRequestInServiceRequestModal = null;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.settingsAmenitiesService.isPaymentModalShow = false;
            this.settingsAmenitiesService.serviceRequestInServiceRequestModal = null;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if(this.fees.length === 1) {
            if(this.fees[0].active === false && this.fees[0].required === false && this.fees[0].name === ''
               && (this.fees[0].amount === '' || this.fees[0].amount === null) &&
               this.fees[0].refundable === false && this.fees[0].pmtAtTime === false && this.fees[0].pmtHourly === false)
                this.fees = [];
            else if(this.fees[0].name && (this.fees[0].amount || this.fees[0].amount === 0)) {
              // need to skip this case, because it is valid
            } else {
                toastr.warning('All payment details should be filled or empty');
                return;
            }
        } else {
            let paymentCanNotBeLessThanZero = false;
            let noNameEntered = false;

            this.fees.filter((fee) => {
                if ((!fee.amount && fee.amount !== 0) || fee.amount < 0)
                    paymentCanNotBeLessThanZero = true;
                if(!fee.name)
                    noNameEntered = true;
            });

            if (paymentCanNotBeLessThanZero) {
                toastr.warning('Payment amount can not be less than 0');
                return;
            }

            if(noNameEntered) {
                toastr.warning('All payment details should be filled or empty');
                return;
            }
        }

        this.disabledSubmit = true;

        let data = null;
        if(this.fees.length == 1) {
            if(!this.fees[0].name && !this.fees[0].payment) {
                data = {
                    fees: [],
                    paymentAcceptCash: false,
                    paymentAcceptCreditCards: false,
                    paymentAcceptCheques: false,
                    paymentAcceptCustomType: false
                };
            } else
                data = { fees : this.fees };
        } else
            data = { fees : this.fees };

        const url = `/v1/amenity/${this.settingsAmenitiesService.selectedItemData.id}.json`;
        this.settingsAmenitiesService.api.patch('domainAmenities', url, data).subscribe(
            () => this.updateView('Payments were successfully updated'),
            error => {
                this.api.errorHandler(error, 'Update failed!');
                this.disabledSubmit = false;
            }
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.settingsAmenitiesService.getData();
        this.form.reset();
        this.hideModal();
    }

    addNewFee(index) {
        this.fees.splice(index + 1, 0, {active: false, required: false, name: '', amount: '0', refundable: false, pmtAtTime: false, pmtHourly: false, availableWaive: false});
    }
    removeFee(index) {
        if(this.fees.length > 1)
            this.fees.splice(index, 1);
        else
            this.fees = [{active: false, required: false, name: '', amount: '', refundable: false, pmtAtTime: false, pmtHourly: false, availableWaive: false}];
    }

    onRefundableChange(event, fee) {
        if(event) {
            fee.pmtAtTime = false;
            fee.pmtHourly = false;
        }
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-amenities/payment-modal/payment-modal.component.ts